import React from "react";
import { ControllerRenderProps, FieldError } from "react-hook-form";
import { CheckboxOptions, ValidationConstraints } from "@/components/tasks/types";
import ValidationEditor from "./shared/ValidationEditor";

interface CheckboxProps {
  name?: string;
  options: CheckboxOptions;
  field: Omit<ControllerRenderProps, "value" | "onChange"> & {
    value: any;
    onChange: (value: any) => void;
  };
  error?: FieldError;
  readOnly?: boolean;
}

export default function Checkbox({
  name,
  field,
  error,
  readOnly,
}: CheckboxProps) {
  const { value, onChange, ...restField } = field;

  return (
    <div className="space-y-2">
      <label className="flex items-center space-x-2 cursor-pointer">
        <input
          {...restField}
          type="checkbox"
          className="text-blue-600 focus:ring-blue-500 rounded"
          disabled={readOnly}
          checked={Boolean(value)}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className="text-gray-700">{name}</span>
      </label>
      {error && <p className="text-sm text-red-600 mt-1">{error.message}</p>}
    </div>
  );
}

interface CheckboxEditorProps {
  options: CheckboxOptions;
  validation: ValidationConstraints;
  onOptionsChange: (options: CheckboxOptions) => void;
  onValidationChange: (validation: ValidationConstraints) => void;
}

Checkbox.Editor = function CheckboxEditor({
  validation,
  onValidationChange,
}: CheckboxEditorProps) {
  return (
    <div className="space-y-4">
      <ValidationEditor
        validation={validation}
        promptType="checkbox"
        onValidationChange={onValidationChange}
      />
    </div>
  );
};
